<header class="wf-peppol-detail-status__header">
  <h3 class="wf-peppol-detail-status__heading wf-text-base-medium">
    {{ 'PEPPOL.Detail.StatusSection' | translate }}
  </h3>

  @if (actions().length) {
    <button
      wui-button
      type="button"
      size="sm"
      [wuiMenu]="actionsMenu"
      [attr.aria-label]="'PEPPOL.Detail.StatusActions' | translate"
    >
      <wf-icon iconName="dots-vertical" iconClass="small" />
    </button>

    <ng-template #actionsMenu>
      @for (action of actions(); track action.key) {
        <wui-option (click)="actionSelected.emit(action.key)">
          <wf-icon
            [iconClass]="action.iconClass"
            [iconName]="action.icon"
            [text]="action.label | translate"
          />
        </wui-option>
      }
    </ng-template>
  }
</header>

<wf-peppol-status-card [event]="event()" />
